import getYouTubeId from 'get-youtube-id'
import YouTube from 'react-youtube'
import { z } from 'zod'

import type { PortableTextTypeComponentProps } from '@portabletext/react'

const youtubePlayer = z.object({
  _key: z.string(),
  _type: z.literal('youtubeVideo'),
  url: z.string(),
})

export const YoutubeVideo = (props: { node: PortableTextTypeComponentProps<unknown> }) => {
  const value = youtubePlayer.parse(props.node.value)
  const videoId = getYouTubeId(value.url)

  if (!videoId) {
    return null
  }

  return (
    <div
      className={
        'relative h-0 w-full overflow-hidden rounded pb-[56.25%] lg:mx-auto lg:my-0 lg:h-[315px] lg:w-[560px] lg:p-0'
      }
    >
      <iframe className={'absolute left-0 top-0 h-full w-full'} title={'YouTube video player'}>
        <YouTube videoId={videoId} />
      </iframe>
    </div>
  )
}
